export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
export const SET_MULTISELECTED_PRODUCTS = 'SET_MULTISELECTED_PRODUCTS';
export const TOGGLE_MULTISELECTED_PRODUCT = 'TOGGLE_MULTISELECTED_PRODUCT';
export const ADD_UPLOAD = 'ADD_UPLOAD';
export const REMOVE_UPLOAD = 'REMOVE_UPLOAD';
export const SET_SELECTED_TIMEZONE = 'SET_SELECTED_TIMEZONE';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_SELECTED_TIME = 'SET_SELECTED_TIME';
export const SET_NOTE = 'SET_NOTE';
export const SET_SIZE = 'SET_SIZE';
export const SET_SOCIAL_MEDIA_LINK = 'SET_SOCIAL_MEDIA_LINK';
export const SET_NAME = 'SET_NAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PHONE = 'SET_PHONE';
export const SET_SELECTED_PRODUCT_ERROR = 'SET_SELECTED_PRODUCT_ERROR';
export const SET_NAME_ERROR = 'SET_NAME_ERROR';
export const SET_EMAIL_ERROR = 'SET_EMAIL_ERROR';
export const SET_PHONE_ERROR = 'SET_PHONE_ERROR';
export const SET_NOTE_ERROR = 'SET_NOTE_ERROR';
export const SET_SIZE_ERROR = 'SET_SIZE_ERROR';
export const SET_NAME_ERRORS_SUPPRESSED = 'SET_NAME_ERRORS_SUPPRESSED';
export const SET_EMAIL_ERRORS_SUPPRESSED = 'SET_EMAIL_ERRORS_SUPPRESSED';
export const SET_PHONE_ERRORS_SUPPRESSED = 'SET_PHONE_ERRORS_SUPPRESSED';
export const SET_NOTE_ERRORS_SUPPRESSED = 'SET_NOTE_ERRORS_SUPPRESSED';
export const SET_SIZE_ERRORS_SUPPRESSED = 'SET_SIZE_ERRORS_SUPPRESSED';
export const SET_CO_DESIGN_SELECTED = 'SET_CO_DESIGN_SELECTED';
export const SET_SELECTED_DESIGNER = 'SET_SELECTED_DESIGNER';

export const SET_AVAILABLE_DATES_SUCCESS = 'SET_AVAILABLE_DATES_SUCCESS';
export const SET_AVAILABLE_DATES_FAILURE = 'SET_AVAILABLE_DATES_FAILURE';
export const SET_AVAILABLE_DATES_LOADING = 'SET_AVAILABLE_DATES_LOADING';

export const SET_AVAILABLE_TIMES_SUCCESS = 'SET_AVAILABLE_TIMES_SUCCESS';
export const SET_AVAILABLE_TIMES_FAILURE = 'SET_AVAILABLE_TIMES_FAILURE';
export const SET_AVAILABLE_TIMES_LOADING = 'SET_AVAILABLE_TIMES_LOADING';

export const SET_ORDER_SUBMITTING = 'SET_ORDER_SUBMITTING';
export const SUBMIT_CO_DESIGN_ORDER_SUCCESS = 'SUBMIT_CO_DESIGN_ORDER_SUCCESS';
export const SUBMIT_CO_DESIGN_ORDER_FAILURE = 'SUBMIT_CO_DESIGN_ORDER_FAILURE';
export const SUBMIT_DIFY_ORDER_SUCCESS = 'SUBMIT_DIFY_ORDER_SUCCESS';
export const SUBMIT_DIFY_ORDER_FAILURE = 'SUBMIT_DIFY_ORDER_FAILURE';
export const SAVE_DIFY_ORDER_SUCCESS = 'SAVE_DIFY_ORDER_SUCCESS';
export const SAVE_DIFY_ORDER_FAILURE = 'SAVE_DIFY_ORDER_FAILURE';

export const SET_DOCUMENT_PAGE_PREVIEW_MODAL_VISIBLE = 'SET_DOCUMENT_PAGE_PREVIEW_MODAL_VISIBLE';
export const SET_DOCUMENT_PAGE_PREVIEW_MODAL_DOCUMENT_PAGE = 'SET_DOCUMENT_PAGE_PREVIEW_MODAL_DOCUMENT_PAGE';

export const SET_SELECTED_PRODUCT_CONFIGURATIONS = 'SET_SELECTED_PRODUCT_CONFIGURATIONS';
export const REMOVE_SELECTED_PRODUCT_CONFIGURATION = 'REMOVE_SELECTED_PRODUCT_CONFIGURATION';



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js